import React from 'react';
import useDarkMode from 'use-dark-mode';

import { ThemeLayout } from 'src/theming';

import { Privileges } from 'src/user-management/privileges/privileges';

import { APP_MODULES } from 'src/shared/constants';

export const PrivilegesPage = (): JSX.Element => {
    const darkMode = useDarkMode();
    return (
        <ThemeLayout darkMode={darkMode} module={APP_MODULES.ADMINISTRATION}>
            <Privileges />
        </ThemeLayout>
    );
};
